var map = {
	"./aks-black.svg": 1839,
	"./aks.svg": 1840,
	"./aliyun-black.svg": 1841,
	"./aliyun.svg": 1842,
	"./aliyunecs-black.svg": 1843,
	"./aliyunecs.svg": 1844,
	"./amazonec2-black.svg": 1845,
	"./amazonec2.svg": 1846,
	"./amazoneks-black.svg": 1847,
	"./amazoneks.svg": 1848,
	"./aws.svg": 1849,
	"./azure-black.svg": 1850,
	"./azure.svg": 1851,
	"./azuread-black.svg": 1852,
	"./azuread.svg": 1853,
	"./azureaks-black.svg": 1854,
	"./azureaks.svg": 1855,
	"./baidu-black.svg": 1856,
	"./baidu.svg": 1857,
	"./cloudca-black.svg": 1858,
	"./cloudca.svg": 1859,
	"./cloudscale-black.svg": 1860,
	"./cloudscale.svg": 1861,
	"./custom.svg": 1862,
	"./digitalocean-black.svg": 1863,
	"./digitalocean.svg": 1864,
	"./equinix-black.svg": 1865,
	"./equinix.svg": 1866,
	"./exoscale.svg": 1867,
	"./gcp.svg": 1868,
	"./gke-black.svg": 1869,
	"./gke.svg": 1870,
	"./google.svg": 1871,
	"./googlegke-black.svg": 1872,
	"./googlegke.svg": 1873,
	"./harvester.svg": 1874,
	"./huaweicce-black.svg": 1875,
	"./huaweicce.svg": 1876,
	"./import.svg": 1877,
	"./k3s-black.svg": 1878,
	"./k3s.svg": 1879,
	"./kubernetes-black.svg": 1880,
	"./kubernetes.svg": 617,
	"./linode.svg": 1881,
	"./linodelke-black.svg": 1882,
	"./linodelke.svg": 1883,
	"./local-cluster.svg": 1884,
	"./minikube-black.svg": 1885,
	"./minikube.svg": 1886,
	"./oci-black.svg": 1887,
	"./oci.svg": 1888,
	"./openstack-black.svg": 1889,
	"./openstack.svg": 1890,
	"./oracle.svg": 1891,
	"./oracleoke-black.svg": 1892,
	"./oracleoke.svg": 1893,
	"./otc-black.svg": 1894,
	"./otc.svg": 1895,
	"./otccce.svg": 1896,
	"./packet-black.svg": 1897,
	"./packet.svg": 1898,
	"./pinganyunecs-black.svg": 1899,
	"./pinganyunecs.svg": 1900,
	"./pnap-black.svg": 1901,
	"./pnap.svg": 1902,
	"./rackspace-black.svg": 1903,
	"./rackspace.svg": 1904,
	"./rke.svg": 1905,
	"./rke2.svg": 1906,
	"./softlayer.svg": 1907,
	"./tencenttke-black.svg": 1908,
	"./tencenttke.svg": 1909,
	"./vmwarevsphere-black.svg": 1910,
	"./vmwarevsphere.svg": 1911
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 616;